import React, { useState } from "react";

export default function OracionesDevocionario() {
  const [fontSizes, setFontSizes] = useState(16);

  const aumentar = () => {
    if (fontSizes < 22) {
      const newSize = fontSizes + 2;
      setFontSizes(newSize);
    }
  };
  const restar = () => {
    if (fontSizes > 12) {
      const newSize = fontSizes - 2;
      setFontSizes(newSize);
    }
  };
  return (
    <>
      <div className="container devocionario">
        <div className={"font-" + fontSizes}>
          <div>
            <h6>AVE MARIA</h6>
            <p>
              Dios te salve, María ; <br />
              llena eres de gracia; el Señor es contigo; <br />
              bendita tú eres entre todas las mujeres, <br />
              y bendito es el fruto de tu vientre, Jesús. <br />
              Santa María, <br />
              Madre de Dios, <br />
              ruega por nosotros, pecadores, ahora y en la hora de nuestra muerte.
              Amén.
            </p>
          </div>
          <div>
            <h6>Gloria al Padre</h6>
            <p>
              Gloria al Padre y al Hijo y al Espíritu Santo. <br />
              Como era en el principio, ahora y siempre, por los siglos de los
              siglos. Amén.
            </p>
          </div>
          <div>
            <h6>Padre Nuestro</h6>
            <p>
              Padre Nuestro, que estás en el cielo, <br />
              santificado sea tu nombre; <br />
              venga a nosotros tu reino; <br />
              hágase tu voluntad, en la tierra como en el cielo. <br />
              Danos hoy nuestro pan de cada día; <br />
              perdona nuestras ofensas, <br />
              como también nosotros perdonamos a los que nos ofenden; <br />
              no nos dejes caer en la tentación, <br />
              y líbranos del mal. <br />
              Amén.
            </p>
          </div>
          <div>
            <h6>El Credo de los Apóstoles</h6>
            <p>
              Creo en Dios Padre, <br />
              Todopoderoso, <br />
              Creador del cielo y de la tierra. Y en Jesucristo, su único Hijo,{" "}
              <br />
              Nuestro Señor, que fue concebido por obra y gracia del Espíritu
              Santo, nació de Santa María Virgen, <br />
              padeció bajo el poder de Poncio Pilato, <br />
              fue crucificado, muerto y sepultado, <br />
              descendió a los infiernos, <br />
              al tercer día resucitó entre los muertos, <br />
              subió a los cielos y está sentado a la derecha de Dios Padre,
              Todopoderoso. <br />
              Desde allí vendrá a juzgar a vivos y a muertos. Creo en el Espíritu
              Santo, la Santa Iglesia Católica, la comunión de los santos, el
              perdón de los pecados, la resurrección de la carne y la vida
              eterna. Amén.
            </p>
          </div>
          <div>
            <h6>SALVE</h6>
            <p>
              Dios te salve, Reina y Madre de misericordia, <br />
              vida, dulzura y esperanza nuestra: <br />
              Dios te salve. <br />
              A ti llamamos los desterrados hijos de Eva; <br />a ti suspiramos,
              gimiendo y llorando en este valle de lágrimas. <br />
              Ea, pues, Señora abogada nuestra, <br />
              vuelve a nosotros esos tus ojos misericordiosos y, <br />
              después de este destierro, <br />
              muéstranos a Jesús, fruto bendito de tu vientre. <br />
              ¡Oh clementísima! ¡oh piadosa! ¡oh dulce Virgen María! <br />
              V. Ruega por nosotros santa Madre de Dios, <br />
              R. Para que seamos dignos de alcanzar las promesas de nuestro Señor
              Jesucristo. <br />
              Amén.
            </p>
          </div>
          <div>
            <h6>PÉSAME</h6>
            <p>
              Pésame, Dios mío, me arrepiento de todo corazón de haberte
              ofendido. Pésame por el infierno que merecí y por el cielo que
              perdí, pero mucho más me pesa porque pecando ofendí a un Dios tan
              bueno y tan grande como Vos. Antes querría haber muerto que haberte
              ofendido; y propongo firmemente no pecar más y evitar las
              ocasiones próximas de pecado. Amén.
            </p>
          </div>
          <div>
            <h6>ORACIÓN A SAN MIGUEL ARCÁNGEL</h6>
            <p>
              San Miguel Arcangel defiendenos en la batalla sé nuestro amparo
              contra la perversidad y asechanzas del demonio. Reprímale Dios pedimos suplicantes y tú, Príncipe de la
              milicia celestial, arroja al infierno con el Divino Poder, a Satanás
              y a los otros espíritus malignos que andan dispersos por el mundo
              para la perdición de las almas. <br />
              Amén
            </p>
          </div>
          <div>
            <h6>El Angelus</h6>
            <i>
              (10 años de Indulgencias por cada vez que se rece e Indulgencia
              Plenaria al mes)
            </i>
            <br/> Se reza las 6 a.m, 12 m y 6 p.m <br />
            <p>
              V. El Ángel del Señor <br />
              anunció a María. <br />
              R.Y concibió por obra y gracia <br />
              del Espíritu Santo.
            </p>
            <p>
              Dios te salve, María... <br />
              Santa María... <br />
              V.He aquí la esclava <br />
              del Señor. <br />
              R. Hágase en mí según <br />
              tu palabra.
            </p>
            <p>
              Dios te salve, María... <br />
              Santa María... <br />
              V. El Verbo se hizo carne. <br />
              R.Y habitó entre nosotros.
            </p>
            <p>
              Dios te salve, María... <br />
              Santa María... <br />
              V. Ruega por nosotros, <br />
              Santa Madre de Dios. <br />
              R. Para que seamos dignos <br />
              de alcanzar las promesas y gracias de Nuestro Señor Jesucristo. <br />
              Amén.
            </p>
            <p>
              <strong>Oración:</strong> <br />
              Oremos:
              Infunde, Señor tu gracia en nuestros almas a fin de que habiendo conocido por la voz del ángel, la encarnación de Cristo tu Hijo, <br />
              por su pasión y su cruz lleguemos a la gloria de su resurrección.  <br />
              Por el mismo Cristo,  Nuestro Señor.  <br />
              Amén.
            </p>
          </div>
          <div>
            <h6>Regina Coeli</h6>
            <i>
              Se reza en lugar del Angelus en el Tiempo Pascual desde la Vigila
              Pascual hasta el medio día del sábado de Pentecostés.
            </i>
            <p>
              V. Alégrate, Reina del cielo. Aleluya. <br />
              R. Porque el que mereciste llevar en tu seno. Aleluya. <br />
              V. Ha resucitado, según predijo. Aleluya. <br />
              R. Ruega por nosotros a Dios. Aleluya. <br />
              V. Gózate y alégrate, Virgen María. Aleluya. <br />
              R. Porque ha resucitado Dios verdaderamente. Aleluya. <br />
              V. Oremos: Oh Dios que por la Resurrección de tu Hijo, nuestro Señor
              Jesucristo, te has dignado dar la alegría al mundo, concédenos por
              su Madre, la Virgen María, alcanzar el gozo de la vida eterna. Por
              el mismo Jesucristo Nuestro Señor. <br />
              R. Amén.
            </p>
          </div>
          <div>
            <h6>Alma de Cristo</h6>
            <p>
              Alma de Cristo, santifícame. <br />
              Cuerpo de Cristo, sálvame. <br />
              Sangre de Cristo, embriágame. <br />
              Agua del Costado de Cristo, lávame. <br />
              Pasión de Cristo, confórtame. <br />
              Oh buen Jesús, óyeme. <br />
              Dentro de tus llagas, escóndeme. <br />
              No permitas que me aparta de Tí. <br />
              Del enemigo malo, defiéndeme. <br />
              En la hora de mi muerte, llámame. <br />
              Y mándame ir a Tí. <br />
              Para que con tus Santos te alabe. <br />
              Por los siglos de los siglos. Amén. <br />
            </p>
          </div>
          <div>
            <h6>Oración a Jesús Crucificado</h6>
            <p>
              Miradme, ¡oh mi amado y buen Jesús!, <br />
              postrado en tu presencia; te ruego con <br />
              el mayor fervor imprimas en mi corazón <br />
              vivos sentimientos de fe, esperanza y <br />
              caridad, verdadero dolor de mis pecados <br />
              y propósito de jamás ofenderte, mientras <br />
              que yo, con el mayor afecto y compasión <br />
              de que soy capaz, voy considerando tus cinco <br />
              llagas, teniendo presente lo que de Tí dijo <br />
              el Santo Profeta David: «Han taladrado mis <br />
              manos y mis pies y se pueden contar todos <br />
              mis huesos.»
            </p>
          </div>
          <div>
            <h6>ACORDAOS</h6>
            <i>(San Bernardo)</i>
            <p>
              Acordaos, oh piadosísima Virgen María!, que jamás se ha oído decir
              que ninguno de los que haya acudido a Vos, implorado vuestra
              asistencia y reclamado vuestro socorro, haya sido abandonado de Vos.
              Animado con esta confianza, a Vos también acudo, oh Virgen, Madre de
              la vírgenes, y aunque gimiendo bajo el peso de mis pecados me atrevo
              a comparecer ante Vuestra presencia Soberana. No desechéis oh
              purísima Madre de Dios mis humildes súplicas, antes bien,
              escuchadlas favorablemente. Así sea.
            </p>
          </div>
        </div>
      </div>
      <div className="btn-fonts d-flex">
        <button onClick={aumentar}>
          <strong>A</strong>
        </button>
        <button onClick={restar} style={{ fontSize: "1.1rem" }}>
          <strong>A</strong>
        </button>
      </div>
    </>
  );
}
